
// 安全隔离：自执行函数，不污染全局变量
(function() {

    function loadScript(url) {
      return new Promise(resolve => {
        const s = document.createElement('script');
        s.src = url;
        s.onload = resolve;
        document.head.appendChild(s);
      });
    }

    window.loadLanguageScript(function(){
        if (document.querySelector('[x-data]')) {
            loadScript('https://cdn.smartorder.ai/assets/js/alpinejs-v3.min.js');
        }
    });

})();